import { createContext, useContext, useState } from "react"

const RouletteStyleContext = createContext();

const RouletteStyleContextProvider = ({ children }) => {

    const [rouletteBackgroundStyle, setRouletteBackgroundStyle] = useState();
    const [rouletteBorderStyle, setRouletteBorderStyle] = useState();
    const [roulettePinStyle, setRoulettePinStyle] = useState();
    const [rouletteStyle, setRouletteStyle] = useState();

    return (
        <RouletteStyleContext.Provider value={{
            rouletteBackgroundStyle, setRouletteBackgroundStyle,
            rouletteBorderStyle, setRouletteBorderStyle,
            roulettePinStyle, setRoulettePinStyle,
            rouletteStyle, setRouletteStyle
        }}>
            {children}
        </RouletteStyleContext.Provider>
    )
}

export default RouletteStyleContextProvider;

export const useRouletteStyleContext = () => {
    return useContext(RouletteStyleContext);
}